module.exports = __webpack_public_path__ + "static/media/warning.5b69a618.svg";